import Handlebars from '@sparta.global.vendors/handlebars';
import * as CommonStringUtils from '@sparta.global.utilities/common-string-utils-utility/dist/es6.js';
import spartaGlobalParams from '@sparta.global.utilities/sparta-global-params-utility/dist/es6.js';

const {
  toCamelCase
} = CommonStringUtils;
const generateIdFromString = str => toCamelCase(str).replace(/\s+/g, '');
const setTriggerAdaLabel = adacaption => adacaption ? `<span class='ada-hidden'>${adacaption}</span>` : '';
function showHide(label, options) {
  let content = '';
  if (options && options.isBlockHelperOptions) {
    const blockHelperTemplate = Handlebars.compile(`${options.helperBlockContent}`);
    content = blockHelperTemplate(label);
    label = label.label;
  } else {
    content = options.fn(this);
  }
  const {
    id,
    classes,
    title,
    adaCaption,
    active
  } = label;

  // set ID
  const setID = id ? id : `${generateIdFromString(title)}-${((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1)}`;

  // class attributes
  const setClasses = classes ? `class="${classes}"` : '';

  // ADA label
  const adaTriggerLabel = setTriggerAdaLabel(adaCaption);

  // add active if open on load
  const activeClass = active ? 'active' : '';

  // build HTML
  const showHideWrap = `<section data-sparta-show-hide-id="${setID}" ${setClasses}>
    <div class="sparta-show-hider ${activeClass}">
      <button class="spa-show-hide-control" type="button" aria-expanded="false" aria-controls="${setID}">
        <label for="${setID}" class="show-hide-button-text">${title}${adaTriggerLabel}</label><span class="chevron spa-icon icon-chevron-down show-hide-button-arrow ${activeClass}"></span>
      </button>
    </div>
    <div class="sparta-show-hidee ${activeClass}" id="${setID}">
      ${content}
    </div>
  </section>
  `;
  return new Handlebars.SafeString(showHideWrap);
}
function showHideList(adaCaption, options) {
  let blockContent = '';
  if (options && options.isBlockHelperOptions) {
    const blockHelperTemplate = Handlebars.compile(`${options.helperBlockContent}`);
    blockContent = blockHelperTemplate(adaCaption);
  } else {
    blockContent = options.fn(this);
  }
  const globalStrings = spartaGlobalParams.getSpaParams({
    context: options,
    lookupKey: 'showHideText',
    defaultObj: {
      collapseAll: 'Collapse All',
      expandAll: 'Expand All'
    }
  });
  const wrapper = `<section class="sparta-show-hide-list">
    <div class="controls hide">
      <button class="sparta-show-hide-expandall spa-btn spa-btn--link" type="button">${globalStrings.expandAll}</button> |
      <button class="sparta-show-hide-collapseall spa-btn spa-btn--link" type="button">${globalStrings.collapseAll}</button>
    </div>
    ${blockContent}
  </section>`;
  return new Handlebars.SafeString(wrapper);
}

export { showHide, showHideList };
